const Appdispute = () =>
    import('@/module/index/layout/Appdispute.vue')
const peoMediation = () =>
    import('@/module/index/pages/dtuMediation/peoMediation.vue')
const adminMediation = () =>
    import('@/module/index/pages/dtuMediation/adminMediation.vue')
const evaluate = () =>
    import('@/module/index/pages/consultation/evaluate.vue')
const evaluateLetter = () =>
    import('@/module/index/pages/consultation/evaluateLetter.vue')
const caseDetail = () =>
    import('@/module/index/pages/userCenter/caseDetail.vue')
export default {
  path: '/',
  component: Appdispute,
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: false
  },
  children: [{
    path: '/peoMediation/:stepId/:disputeId', // 人民调解
    name: 'peoMediation',
    component: peoMediation
  },
  {
    path: '/adminMediation/:stepId/:disputeId', // 行政调解
    name: 'adminMediation',
    component: adminMediation
  },
  {
    path: '/consultation/evaluate/:caseId/:mediatorId', // 人工咨询--评价
    name: 'evaluate',
    component: evaluate
  },
  {
    path: '/consultation/evaluateLetter/:caseId/:petitionAgentUserId/:caseNo', // 信访代理人--评价
    name: 'evaluateLetter',
    component: evaluateLetter
  },
  {
    path: '/userCenter/caseDetail/:caseId/:caseType', // 案件详情
    name: 'caseDetail',
    component: caseDetail
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/disputeMediation.js